import { graphql } from "@opensea/graphql"

export const TokenSwapPriceFragment = graphql(
  `
    fragment TokenSwapPrice on TokenSwapActivity {
      fromToken {
        usd
        token {
          unit
        }
      }
      toToken {
        usd
        token {
          unit
        }
      }
    }
  `,
  [],
)
